// Copyright (c) 2016 Deere & Company

export const SERVICE_PART_FAILURE = '07';
export const UPTIME_ASSURANCE = '12';



// WEBPACK FOOTER //
// ./src/claim/spa/constants/index.js